import { PATHS as _PATHS } from "@/constants/path"
import { RoutesPages as Pages, RoutesPagesLoader } from "@/pages"
import { accountRoutes } from "@/pages/AccountPage/routes"
import {
    gameCategorySubPageRoutes,
    gameSectionsPageRoutes,
    homeSubPageRoutes,
} from "@/pages/HomePage/routes"
import { transactionRecordRoutes } from "@/pages/TransactionRecordPage/routes"
import { myRoutes } from "@/pages/UserCenterPage/routes"
import { welfareRoutes } from "@/pages/Walfare/routes"
import ENV from "@/utils/env"
import { RouteObject } from "react-router-dom"
import { AuthGuard } from "./AuthGuard"
import { ROUTES_REDIRECT } from "./routes_redirect"
import { createLogger } from "@/utils/logger"

const logger = createLogger("routes")

export const PATHS = _PATHS

export const ROUTES_DEV: RouteObject[] = []

export const ROUTES_PROTECTED: RouteObject[] = [
    {
        path: "",
        Component: AuthGuard,
        children: [
            {
                path: PATHS.VIP,
                lazy: Pages.VipPage,
            },
            {
                path: PATHS.VIP_LEVEL_SYSTEM,
                lazy: Pages.LevelSystem,
            },
            {
                path: PATHS.POINTS,
                lazy: Pages.PointsPage,
            },
            {
                path: PATHS.MY,
                lazy: Pages.UserCenterPage,
                children: [...myRoutes],
            },
            {
                path: PATHS.ACCOUNT,
                lazy: Pages.AccountPage,
                children: [...accountRoutes],
            },
            {
                path: PATHS.TRANSACTION,
                lazy: Pages.TransactionRecordPage,
                children: [...transactionRecordRoutes],
            },
            {
                path: PATHS.TRANSACTION_STATUS,
                lazy: Pages.TransactionStatusPage,
            },
            {
                path: PATHS.BET_RECORD,
                lazy: Pages.BetRecordPage,
            },
            {
                path: PATHS.WELFARE,
                children: [...welfareRoutes],
            },
            {
                path: PATHS.BLIND_BOX,
                lazy: Pages.BlindBox,
            },
            {
                path: PATHS.DAILY_WINS,
                lazy: Pages.DailyWins,
            },
            {
                path: PATHS.INVITE,
                lazy: Pages.InvitePage,
            },
            {
                path: PATHS.GAME_PAGE,
                lazy: Pages.GamePage,
            },
            {
                path: PATHS.WITHDRAW_ACCOUNTS,
                lazy: Pages.WithdrawAccounts,
            },
            {
                path: PATHS.KYC,
                lazy: Pages.KycPage,
            },
        ],
    },
]

// 路由配置
export const ROUTES: RouteObject[] = [
    {
        path: PATHS.INDEX,
        lazy: Pages.HomePage,
        children: [...homeSubPageRoutes],
    },
    {
        path: PATHS.GAME_CATEGORY,
        lazy: Pages.HomePage,
        children: [...gameCategorySubPageRoutes],
    },
    {
        path: PATHS.SECTIONS,
        lazy: Pages.HomePage,
        children: [...gameSectionsPageRoutes],
    },
    {
        path: `${PATHS.LOGIN}`,
        lazy: Pages.LoginPageV2,
    },
    {
        path: `${PATHS.DOCS}/:name`,
        lazy: Pages.DocsPage,
    },
    {
        path: PATHS.DOWNLOAD,
        lazy: Pages.DownloadPage,
    },
    ...ROUTES_REDIRECT,
    ...ROUTES_PROTECTED,
    ...(ENV.dev_mode ? ROUTES_DEV : []),
    {
        path: "*",
        lazy: Pages.NotFoundPage,
    },
]

console.log("ROUTES,", ROUTES)
